import * as React from 'react';
import { BinaryLinkModel } from './BinaryLinkModel';
import { BinaryLinkWidget } from './BinaryLinkWidget';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';
export const Keyframes = keyframes`
		from {
			stroke-dashoffset: 24;
		}
		to {
			stroke-dashoffset: 0;
		}
	`;
const selected = css`
		stroke-dasharray: 10, 2;
		animation: ${Keyframes} 1s linear infinite;
	`;
export const Path = styled.path`
		${p => p.selected && selected};
		fill: none;
		pointer-events: all;
	`;
export class BinaryLinkFactory extends AbstractReactFactory {
  constructor(type = 'binary') {
    super(type);
  }

  generateReactWidget(event) {
    return /*#__PURE__*/React.createElement(BinaryLinkWidget, {
      link: event.model,
      diagramEngine: this.engine
    });
  }

  generateModel(event) {
    return new BinaryLinkModel();
  }

  generateLinkSegment(model, selected, path) {
    return /*#__PURE__*/React.createElement(Path, {
      selected: selected,
      stroke: selected ? model.getOptions().selectedColor : model.getOptions().color,
      strokeWidth: model.getOptions().width,
      d: path
    });
  }

}